import { Component, ViewChild } from "@angular/core";
import { EJComponents } from "ej-angular2/src/ej/core";
import {
  ReactiveFormsModule,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { CraneListService } from "../../services/craneListService";
import { Router } from "@angular/router";
import { AppStateService } from "../../services/appState.service";
import * as allgemeineFunktionen from "../../allgemeinesTS_CSS/allgemeineHilfsfunktionen";

@Component({
  selector: "app-crane-setup",
  template: "Not of use ...",
  providers: [CraneListService],
})
export class KranSetupAllgemeinComponent {
  @ViewChild("KranTabelle") KranFilterTabelle: EJComponents<any, any>;
  public SetupForm: FormGroup;
  protected ladeKran = false;
  protected ladeRuestzustand = false;
  public tabellenEinstellungen: Object = {};
  public gewichtsEinheit = "t";
  public laengenEinheit = "m";
  protected kranKennung: Object = {};
  public RHLRadius: string;
  public RHLHoehe: string;
  public RHLLast: string;
  protected ruestFilter: Object = {};
  // Arrays für auswaehlbare Ruestzustaende
  public identnummern: string[] = [""];
  public gegengewichte: string[] = [""];
  public abstuetzungen: string[] = [""];
  public haLaengen: string[] = [""];
  public haAusfahrfolgen: string[] = [""];
  // Werte gesetzter Rüstzustände
  public kranname = "";
  public gesetzteIdentnr = "";
  public kombinationen: string[] = [];
  public gesetzteKombination = "";
  public gesetztesGegengew = "";
  public gesetzteAbstuetzung = "";
  public gesetzteHALaenge = "";
  public gesetzteHAAusfahrf = "";
  public filterSettings: object = { filterType: "filterbar" };
  // Fehler- Ausgabe
  public FehlerUeberschrift = "";
  public FehlerHinweis = "";
  public FehlerCallback: Function;
  public zeigeFehlerMeldung = false;
  public gridData: Object[] = [];
  // Funktionssteuerung
  protected aendereWerte: any; // NodeJS.Timer;
  public zeigeSortierInfos = false;
  protected stellenNachEinheitenSystem: number;
  constructor(
    private fb_super: FormBuilder,
    private craneListService_super: CraneListService,
    private router_super: Router,
    private appStateService_super: AppStateService
  ) {}
  einlesenRuestdaten(res) {
    this.ruestFilter = {};
    for (const filter in res) {
      if (res.hasOwnProperty(filter)) {
        this.ruestFilter[filter] = res[filter];
      }
    }
    if (res["Identnr"] !== undefined) {
      this.gesetzteIdentnr = res["Identnr"];
      this.KranFilterTabelle.widget.filterColumn(
        "Identnr",
        "equal",
        this.gesetzteIdentnr,
        "and",
        true
      );
    } else {
      this.gesetzteIdentnr = "";
      this.KranFilterTabelle.widget.clearFiltering("Identnr");
    }

    if (res["Gegengewicht"] !== undefined) {
      this.gesetztesGegengew = res["Gegengewicht"];
      this.SetupForm.get("Gegengew").setValue(this.gesetztesGegengew);
      this.KranFilterTabelle.widget.filterColumn(
        "Gegengew",
        "equal",
        this.gesetztesGegengew,
        "and",
        true
      );
    } else {
      this.gesetztesGegengew = "";
      this.SetupForm.get("Gegengew").setValue("");
      this.KranFilterTabelle.widget.clearFiltering("Gegengew");
    }
    if (res["HALaenge"] !== undefined) {
      this.gesetzteHALaenge = res["HALaenge"];
      this.SetupForm.get("HALaenge").setValue(this.gesetzteHALaenge);
      this.KranFilterTabelle.widget.filterColumn(
        "HALaenge",
        "equal",
        this.gesetzteHALaenge,
        "and",
        true
      );
    } else {
      this.gesetzteHALaenge = res["HALaenge"] = "";
      this.SetupForm.get("HALaenge").setValue("");
      this.KranFilterTabelle.widget.clearFiltering("HALaenge");
    }

    if (res["HAAusfahrf"] !== undefined) {
      this.gesetzteHAAusfahrf = res["HAAusfahrf"];
      this.KranFilterTabelle.widget.filterColumn(
        "HAAusfahrf",
        "equal",
        this.gesetzteHAAusfahrf,
        "and",
        true
      );
    } else {
      this.gesetzteHAAusfahrf = "";
      this.KranFilterTabelle.widget.clearFiltering("HAAusfahrf");
    }
    this.SetupForm.get("HAAusfahrf").setValue(this.gesetzteHAAusfahrf);
  }
  ladeRuestzustaende(kranDaten) {
    // XXX schauen ob das wirklich raus konnte
    // this.appStateService_super.kranGewaehltNeu(this.kranKennung);
    this.identnummern = [""];
    this.gegengewichte = [""];
    this.haLaengen = [""];
    this.haAusfahrfolgen = [""];
    this.abstuetzungen = [""];
    this.kombinationen = [""];
    Array.prototype.push.apply(this.identnummern, kranDaten["Identnummern"]);
    Array.prototype.push.apply(this.gegengewichte, kranDaten["Gegengewichte"]);
    Array.prototype.push.apply(this.haLaengen, kranDaten["HALaengen"]);
    Array.prototype.push.apply(this.kombinationen, kranDaten["Kombinationen"]);
    Array.prototype.push.apply(
      this.haAusfahrfolgen,
      kranDaten["HAAusfahrfolgen"]
    );
    // ist nur ein Wert in Auswahl soll dieser angezeigt werden.
    if (this.kombinationen.length === 2) {
      this.gesetzteKombination = this.kombinationen[1];
      this.KranFilterTabelle.widget.clearFiltering("Kombination");
      this.KranFilterTabelle.widget.filterColumn(
        "Kombination",
        "equal",
        this.gesetzteKombination,
        "and",
        true
      );
    }
    // Abstuetzungen werden in den erbenden Klassen eingelesen, da sich verhalten bei 360° und MAXbase unterscheiden.
    if (this.identnummern.length === 2) {
      this.gesetzteIdentnr = this.identnummern[1];
      this.KranFilterTabelle.widget.clearFiltering("Identnr");
      this.KranFilterTabelle.widget.filterColumn(
        "Identnr",
        "equal",
        this.gesetzteIdentnr,
        "and",
        true
      );
    }
    if (this.gegengewichte.length === 2) {
      this.gesetztesGegengew = this.gegengewichte[1];
      this.KranFilterTabelle.widget.clearFiltering("Gegengew");
      this.KranFilterTabelle.widget.filterColumn(
        "Gegengew",
        "equal",
        this.gesetztesGegengew,
        "and",
        true
      );
    }
    if (this.haLaengen.length === 2) {
      this.gesetzteHALaenge = this.haLaengen[1];
      this.SetupForm.get("HALaenge").setValue(this.gesetzteHALaenge);
      this.KranFilterTabelle.widget.clearFiltering("HALaenge");
      this.KranFilterTabelle.widget.filterColumn(
        "HALaenge",
        "equal",
        this.gesetzteHALaenge,
        "and",
        true
      );
    }
    if (this.haAusfahrfolgen.length === 2) {
      this.gesetzteHAAusfahrf = this.haAusfahrfolgen[1];
      this.SetupForm.get("HAAusfahrf").setValue(this.haAusfahrfolgen[1]);
      this.KranFilterTabelle.widget.clearFiltering("HAAusfahrf");
      this.KranFilterTabelle.widget.filterColumn(
        "HAAusfahrf",
        "equal",
        this.gesetzteHAAusfahrf,
        "and",
        true
      );
    }
    this.ladeRuestzustand = false;
    console.log("Ruestzustaende: " + allgemeineFunktionen.holeUhrzeit());
  }
  ruestzustandAendern(event: any) {
    let zuAendernderRuestzustand = event.target.id;
    const neuerWert = event.target.value;
    if (zuAendernderRuestzustand.indexOf("HI1") >= 0) {
      zuAendernderRuestzustand = zuAendernderRuestzustand.replace("HI1", "HI");
    }
    //    if (neuerWert === '') {
    //      this.KranFilterTabelle.widget.clearFiltering(zuAendernderRuestzustand);
    //      if (zuAendernderRuestzustand === 'HALaenge') {
    //        this.KranFilterTabelle.widget.clearFiltering('HAAusfahrf');
    //        this.gesetzteHAAusfahrf = '';
    //      } else if (zuAendernderRuestzustand === 'HAAusfahrf') {
    //        this.KranFilterTabelle.widget.clearFiltering('HALaenge');
    //        this.gesetzteHALaenge = '';
    //      }
    //    } else {
    //      this.KranFilterTabelle.widget.filterColumn(zuAendernderRuestzustand, 'equal', neuerWert, 'and', true);
    //    }
    if (neuerWert !== "") {
      this.KranFilterTabelle.widget.filterColumn(
        zuAendernderRuestzustand,
        "equal",
        neuerWert,
        "and",
        true
      );
    } else {
      this.KranFilterTabelle.widget.clearFiltering(zuAendernderRuestzustand);
    }
    switch (zuAendernderRuestzustand) {
      case "Kombination":
        this.gesetzteKombination = neuerWert;
        break;
      case "Identnr":
        this.gesetzteIdentnr = neuerWert;
        this.KranFilterTabelle.widget.clearFiltering("AbstuetzW");
        break;
      case "Gegengew":
        this.gesetztesGegengew = neuerWert;
        break;
      case "HALaenge":
        this.gesetzteHALaenge = neuerWert;
        this.SetupForm.get("HALaenge").setValue(this.gesetzteHALaenge);
        this.gesetzteHAAusfahrf = "";
        if (neuerWert === "") {
          this.KranFilterTabelle.widget.clearFiltering("HAAusfahrf");
          this.gesetzteHAAusfahrf = "";
        }
        this.SetupForm.get("HAAusfahrf").setValue(this.gesetzteHAAusfahrf);
        break;
      case "HAAusfahrf":
        this.gesetzteHAAusfahrf = neuerWert;
        this.SetupForm.get("HAAusfahrf").setValue(this.gesetzteHALaenge);
        this.gesetzteHALaenge = "";
        if (neuerWert === "") {
          this.KranFilterTabelle.widget.clearFiltering("HALaenge");
          this.gesetzteHALaenge = "";
        }
        this.SetupForm.get("HALaenge").setValue(this.gesetzteHALaenge);
        break;
      default:
        break;
    }
  }

  setzeHALaengeAusfahrf(zuAendernderRuestzustand: string) {
    if (
      zuAendernderRuestzustand === "HALaenge" ||
      zuAendernderRuestzustand === "HAAusfahrf"
    ) {
      this.craneListService_super
        .holePassendeHALaengeUndAusfahrfolge(
          zuAendernderRuestzustand === "HALaenge" ? this.gesetzteHALaenge : "",
          zuAendernderRuestzustand === "HAAusfahrf"
            ? this.gesetzteHAAusfahrf
            : ""
        )
        .then((res) => {
          if (
            allgemeineFunktionen.isset(res["HALaengen"]) &&
            res["HALaengen"].length === 1
          ) {
            this.gesetzteHALaenge = res["HALaengen"][0];
            this.KranFilterTabelle.widget.filterColumn(
              "HALaenge",
              "equal",
              this.gesetzteHALaenge,
              "and",
              true
            );
          } else {
            this.gesetzteHALaenge = "";
            this.KranFilterTabelle.widget.clearFiltering("HALaenge");
          }
          if (
            allgemeineFunktionen.isset(res["HAAusfahrf"]) &&
            res["HAAusfahrf"].length === 1
          ) {
            this.gesetzteHAAusfahrf = res["HAAusfahrf"][0];
            this.KranFilterTabelle.widget.filterColumn(
              "HAAusfahrf",
              "equal",
              this.gesetzteHAAusfahrf,
              "and",
              true
            );
          } else {
            this.gesetzteHAAusfahrf = "";
            this.KranFilterTabelle.widget.clearFiltering("HAAusfahrf");
          }
        });
    }
    this.SetupForm.get("HAAusfahrf").setValue(this.gesetzteHAAusfahrf);
    this.SetupForm.get("HALaenge").setValue(this.gesetzteHALaenge);
  }

  holeKranRuestzustaende(
    Identnr = "",
    Gegengew = "",
    HALAenge = "",
    AbstuetzW = "",
    HAAusfahrf = "",
    Abstuetzverteilung = "VH",
    Drehrichtung = "0",
    Kombination = "",
    HAWinkel = "",
    HI1Laenge = "",
    HI1Winkel = ""
  ): Promise<any> {
    this.ladeRuestzustand = true;
    return this.craneListService_super
      .getFilteredPartsSelectionData(
        Kombination,
        Identnr,
        Gegengew,
        HALAenge,
        HAWinkel,
        HI1Laenge,
        HI1Winkel,
        AbstuetzW,
        HAAusfahrf,
        Abstuetzverteilung,
        Drehrichtung
      )
      .then((res) => this.ladeRuestzustaende(res));
  }
  ladeTabelle(tabelle) {
    this.gridData = [];
    for (const zeile of tabelle) {
      this.gridData.push({
        Pointer: parseInt(zeile["Pointer"], 10),
        Geraet: zeile["Geraet"],
        Identnr: parseInt(zeile["Identnr"], 10),
        Pruefnorm: zeile["Pruefnorm"],
        Kombination: zeile["Kombination"],
        HALaenge: parseFloat(zeile["HALaenge"]),
        HAWinkel:
          zeile["HAWinkel"] === null ? null : parseFloat(zeile["HAWinkel"]),
        HAAusfahrf: zeile["HAAusfahrf"],
        HILaenge:
          zeile["HILaenge"] === null ? null : parseFloat(zeile["HILaenge"]),
        HIWinkel:
          zeile["HIWinkel"] === null ? null : parseFloat(zeile["HIWinkel"]),
        Gegengew: parseFloat(zeile["Gegengew"]),
        Zentralblst:
          zeile["Zentralblst"] === null ? "" : parseFloat(zeile["Zentralblst"]),
        AbstuetzW: zeile["AbstuetzW"],
        Einscher: zeile["Einscher"],
        Drehber: zeile["Drehber"],
        Drehrichtung: parseInt(zeile["Drehrichtung"], 10),
        minRadius: parseFloat(zeile["minRadius"]),
        maxRadius: parseFloat(zeile["maxRadius"]),
        maxHoehe: parseFloat(zeile["maxHoehe"]),
        maxLast: parseFloat(zeile["maxLast"]),
      });
      if (zeile["AbstuetzW"].indexOf("HL") > -1) {
        this.gridData.push({
          Pointer: parseInt(zeile["Pointer"], 10),
          Geraet: zeile["Geraet"],
          Identnr: parseInt(zeile["Identnr"], 10),
          Pruefnorm: zeile["Pruefnorm"],
          Kombination: zeile["Kombination"],
          HALaenge: parseFloat(zeile["HALaenge"]),
          HAWinkel:
            zeile["HAWinkel"] === null ? null : parseFloat(zeile["HAWinkel"]),
          HAAusfahrf: zeile["HAAusfahrf"],
          HILaenge:
            zeile["HILaenge"] === null ? null : parseFloat(zeile["HILaenge"]),
          HIWinkel:
            zeile["HIWinkel"] === null ? null : parseFloat(zeile["HIWinkel"]),
          Gegengew: parseFloat(zeile["Gegengew"]),
          Zentralblst:
            zeile["Zentralblst"] === null
              ? ""
              : parseFloat(zeile["Zentralblst"]),
          AbstuetzW: zeile["AbstuetzW"].replace("HL", "HR"),
          Einscher: zeile["Einscher"],
          Drehber: this.spiegleDrehbereich(
            zeile["Drehber"],
            zeile["Drehrichtung"]
          ),
          Drehrichtung: parseInt(
            this.spiegelDrehrichtung(zeile["Drehrichtung"]),
            10
          ),
          minRadius: parseFloat(zeile["minRadius"]),
          maxRadius: parseFloat(zeile["maxRadius"]),
          maxHoehe: parseFloat(zeile["maxHoehe"]),
          maxLast: parseFloat(zeile["maxLast"]),
        });
      } else if (zeile["AbstuetzW"].indexOf("VL") > -1) {
        this.gridData.push({
          Pointer: parseInt(zeile["Pointer"], 10),
          Geraet: zeile["Geraet"],
          Identnr: parseInt(zeile["Identnr"], 10),
          Pruefnorm: zeile["Pruefnorm"],
          Kombination: zeile["Kombination"],
          HALaenge: parseFloat(zeile["HALaenge"]),
          HAWinkel:
            zeile["HAWinkel"] === null ? null : parseFloat(zeile["HAWinkel"]),
          HAAusfahrf: zeile["HAAusfahrf"],
          HILaenge:
            zeile["HILaenge"] === null ? null : parseFloat(zeile["HILaenge"]),
          HIWinkel:
            zeile["HIWinkel"] === null ? null : parseFloat(zeile["HIWinkel"]),
          Gegengew: parseFloat(zeile["Gegengew"]),
          Zentralblst:
            zeile["Zentralblst"] === null
              ? ""
              : parseFloat(zeile["Zentralblst"]),
          AbstuetzW: zeile["AbstuetzW"].replace("VL", "VR"),
          Einscher: zeile["Einscher"],
          Drehber: this.spiegleDrehbereich(
            zeile["Drehber"],
            zeile["Drehrichtung"]
          ),
          Drehrichtung: parseInt(
            this.spiegelDrehrichtung(zeile["Drehrichtung"]),
            10
          ),
          minRadius: parseFloat(zeile["minRadius"]),
          maxRadius: parseFloat(zeile["maxRadius"]),
          maxHoehe: parseFloat(zeile["maxHoehe"]),
          maxLast: parseFloat(zeile["maxLast"]),
        });
      } else if (zeile["AbstuetzW"].indexOf("RL") > -1) {
        this.gridData.push({
          Pointer: parseInt(zeile["Pointer"], 10),
          Geraet: zeile["Geraet"],
          Identnr: parseInt(zeile["Identnr"], 10),
          Pruefnorm: zeile["Pruefnorm"],
          Kombination: zeile["Kombination"],
          HALaenge: parseFloat(zeile["HALaenge"]),
          HAWinkel:
            zeile["HAWinkel"] === null ? null : parseFloat(zeile["HAWinkel"]),
          HAAusfahrf: zeile["HAAusfahrf"],
          HILaenge:
            zeile["HILaenge"] === null ? null : parseFloat(zeile["HILaenge"]),
          HIWinkel:
            zeile["HIWinkel"] === null ? null : parseFloat(zeile["HIWinkel"]),
          Gegengew: parseFloat(zeile["Gegengew"]),
          Zentralblst:
            zeile["Zentralblst"] === null
              ? ""
              : parseFloat(zeile["Zentralblst"]),
          AbstuetzW: zeile["AbstuetzW"].replace("RL", "LR"),
          Einscher: zeile["Einscher"],
          Drehber: this.spiegleDrehbereich(
            zeile["Drehber"],
            zeile["Drehrichtung"]
          ),
          Drehrichtung: parseInt(
            this.spiegelDrehrichtung(zeile["Drehrichtung"]),
            10
          ),
          minRadius: parseFloat(zeile["minRadius"]),
          maxRadius: parseFloat(zeile["maxRadius"]),
          maxHoehe: parseFloat(zeile["maxHoehe"]),
          maxLast: parseFloat(zeile["maxLast"]),
        });
      }
    }
    this.ladeKran = false;
  }
  spiegelDrehrichtung(zeile: string) {
    switch (zeile) {
      case "1":
      case "2":
        return zeile;
      case "3":
        return "4";
      case "4":
        return "3";
    }
  }
  spiegleDrehbereich(wert: string, drehbereich: string): string {
    switch (drehbereich) {
      case "3":
      case "4":
        const AnfangEnde = wert.split("-");
        const Anfang = this.spiegleWinkel(parseFloat(AnfangEnde[0])).toString();
        const Ende = this.spiegleWinkel(parseFloat(AnfangEnde[1])).toString();
        return (
          Math.min(parseFloat(Anfang), parseFloat(Ende)) +
          " - " +
          Math.max(parseFloat(Anfang), parseFloat(Ende))
        );
      case "1":
      case "2":
        return wert;
    }
  }
  spiegleWinkel(winkel: number): number {
    while (winkel > 360) {
      winkel = winkel % 360;
    }
    return 360 - winkel;
  }
  kranGewaehlt(): boolean {
    if (
      this.KranFilterTabelle.widget === undefined ||
      this.KranFilterTabelle.widget.getSelectedRecords()[0] === undefined
    ) {
      return false;
    } else {
      return true;
    }
  }
  rowSelected() {
    this.kranKennung["kranDatenbankNamen"] =
      this.kranKennung["kranDatenbankNamen"];
    this.kranKennung["pointer"] =
      this.KranFilterTabelle.widget.getSelectedRecords()[0].Pointer;
    this.appStateService_super.kranGewaehltNeu(this.kranKennung);
    const menueStartStatus: Object = {
      CraneSetup: "active",
      CraneControl: "active",
    };
    this.appStateService_super.meuePunktStatusSetzen(menueStartStatus);
  }
  bitteWarten() {
    return this.ladeKran || this.ladeRuestzustand;
  }
  zeigeFehler(Ueberschrift: string, Hinweis: string, callback: Function) {
    this.zeigeFehlerMeldung = true;
    this.FehlerUeberschrift = Ueberschrift;
    this.FehlerHinweis = Hinweis;
    this.FehlerCallback = callback;
  }
  resetFilter(art = "alles") {
    this.KranFilterTabelle.widget.clearFiltering();
    if (art === "alles") {
      this.RHLRadius = "";
      this.SetupForm.get("Radius").setValue("");
      this.RHLLast = "";
      this.SetupForm.get("Last").setValue("");
      this.RHLHoehe = "";
      this.SetupForm.get("Hoehe").setValue("");
    }
    this.sucheKran();
    this.gesetzteIdentnr = "";
    this.gesetztesGegengew = "";
    this.gesetzteAbstuetzung = "";
    this.gesetzteHALaenge = "";
    this.SetupForm.get("HALaenge").setValue(this.gesetzteHALaenge);
    this.gesetzteHAAusfahrf = "";
    this.SetupForm.get("HAAusfahrf").setValue(this.gesetzteHAAusfahrf);
    return true;
  }
  sucheKran(Abstuetzverteilung: string = "") {
    this.ladeRuestzustand = true;
    this.ladeKran = true;
    if (this.RHLRadius === null) {
      this.RHLRadius = "";
    }
    if (this.RHLLast === null) {
      this.RHLLast = "";
    }
    if (this.RHLHoehe === null) {
      this.RHLHoehe = "";
    }
    this.appStateService_super.appStatusSetzen({
      RHLRadius: this.RHLRadius,
      RHLLast: this.RHLLast,
      RHLHoehe: this.RHLHoehe,
    });
    this.craneListService_super
      .getPartsSelectionData(
        this.kranKennung["kranDatenbankNamen"],
        Abstuetzverteilung,
        this.RHLRadius.replace(",", "."),
        this.RHLLast.replace(",", "."),
        this.RHLHoehe.replace(",", ".")
      )
      .then((res) => {
        this.ladeRuestzustaende(res);
        this.craneListService_super
          .getKranTabelle(this.kranKennung["kranDatenbankNamen"])
          .then((res1) => {
            this.ladeTabelle(res1);
            this.SetupForm.updateValueAndValidity();
          });
      });
  }
  goBack() {
    this.router_super.navigate(["/craneSelection"]);
  }
  sortierInfoZeigenUmschalten() {
    this.zeigeSortierInfos = !this.zeigeSortierInfos;
  }
  rundeHAWerte(Zahl: string, Stellen: number = 2) {
    if (Zahl === "") {
      return "";
    }
    return allgemeineFunktionen.rundeZahl(parseFloat(Zahl), Stellen);
  }
}
